import {
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export const HowItWorksView = ({ onClose }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        zIndex: 1100,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          pt: "60px",
          pb: "40px",
        }}
      >
        <Typography
          sx={{
            fontSize: 30,
            fontWeight: "bold",
            color: "yellow",
          }}
        >
          How it works
        </Typography>

        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 30,
            backgroundColor: "rgba(0,0,0,0.5)",
            color: "white",
            borderRadius: "50%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.4)",
            "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
          }}
        >
          <ArrowForwardIcon fontSize="large" />
        </IconButton>
      </Box>

      {/* Content */}
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Box
          component="img"
          src="/hiw_step_2.gif"
          alt="Activate Experience"
          sx={{
            width: 360,
            height: 402,
            objectFit: "cover",
            borderRadius: 2,
            border: "3px solid white",
          }}
        />

        <Typography
          sx={{
            fontSize: 24,
            fontWeight: "bold",
            color: "yellow",
            mt: 2,
          }}
        >
          Activate Experience
        </Typography>

        <Typography
          sx={{
            color: "white",
            fontWeight: "bold",
            textAlign: "center",
            px: 3,
            mt: 1,
            maxWidth: 400,
          }}
        >
          Point camera at image and tap the green 'scan' button
        </Typography>
      </Box>
    </Box>
  );
};